// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._fadeTransition_jU0YE {
	transition: all var(--animation-quick) ease;
}
._fadeTransitionActive_rY40O {
	opacity: 0;
	position: absolute;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcBlurHash-CloqLmG2.css"],"names":[],"mappings":";AACA;CACC,2CAA2C;AAC5C;AACA;CACC,UAAU;CACV,kBAAkB;AACnB","sourcesContent":["\n._fadeTransition_jU0YE {\n\ttransition: all var(--animation-quick) ease;\n}\n._fadeTransitionActive_rY40O {\n\topacity: 0;\n\tposition: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
